import { render, staticRenderFns } from "./CustomerPortalWrapper.vue?vue&type=template&id=65ffef63&scoped=true&"
import script from "./CustomerPortalWrapper.vue?vue&type=script&lang=js&"
export * from "./CustomerPortalWrapper.vue?vue&type=script&lang=js&"
import style0 from "./CustomerPortalWrapper.vue?vue&type=style&index=0&id=65ffef63&prod&scoped=true&lang=css&"
import style1 from "./CustomerPortalWrapper.vue?vue&type=style&index=1&id=65ffef63&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ffef63",
  null
  
)

export default component.exports